<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
export default {
  name: 'ReferralCountListPage',
  data () {
    return {
      columnConfig: [
        {
          columnCode: 'memberChatId',
          columnName: 'Chat Id',
          align: 'left',
          value: item => {
            return item.memberChatId
          }
        },
        {
          columnCode: 'memberPhone',
          columnName: 'Phone',
          align: 'left',
          value: item => {
            return item.memberPhone
          }
        },
        {
          columnCode: 'count',
          columnName: 'Count',
          align: 'left',
          value: item => {
            return item.count
          }
        },
        {
          columnCode: 'link',
          columnName: 'Link',
          align: 'left',
          value: item => {
            return item.link
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.get('referral/link-count', payload)
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dashboard/ReferralCountListPage.vue